// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settingBlock__EGXms {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 19px;
  border-radius: 5px;
  border: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-secondary-row-sub-title-surface);
  height: 45px;
}

.collapseTitle__FNPju {
  font-size: 11px;
  font-weight: 500;
  line-height: 13px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--tables-secondary-row-sub-title-text);
  display: flex;
  align-items: center;
}

.arrowIcon__E4gyr {
  width: 15px;
  height: 15px;
  margin-right: 20px;
  transform: rotate(-90deg);
  cursor: pointer;
}
.arrowIcon__E4gyr path {
  fill: var(--tables-secondary-row-sub-title-icon);
}

.arrowIconOpen__qfpwp {
  transform: rotate(0deg);
}

.settingItemInfo__WlfpV {
  margin-top: -15px;
  border-radius: 0 5px;
  transition: all 0.5s ease-in-out;
  border: 1px solid var(--tables-primary-row-stroke);
  border-top: none;
  background: var(--tables-secondary-row-sub-title-surface);
}

.settingItemInfoText__e7kjd {
  margin-bottom: 0;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: var(--tables-secondary-row-sub-title-text);
  padding: 15px 13px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/PrivacyPolicySettingsModal/components/SettingItem/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kDAAA;EACA,yDAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,iDAAA;EACA,aAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAzEF;AA2EE;EACE,gDAAA;AAzEJ;;AA6EA;EACE,uBAAA;AA1EF;;AA6EA;EACE,iBAAA;EACA,oBAAA;EACA,gCAAA;EACA,kDAAA;EACA,gBAAA;EACA,yDAAA;AA1EF;;AA6EA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iDAAA;EACA,kBAAA;AA1EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.settingBlock {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px 19px;\n  border-radius: 5px;\n  border: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-secondary-row-sub-title-surface);\n  height: 45px;\n}\n\n.collapseTitle {\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 13px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--tables-secondary-row-sub-title-text);\n  display: flex;\n  align-items: center;\n}\n\n.arrowIcon {\n  width: 15px;\n  height: 15px;\n  margin-right: 20px;\n  transform: rotate(-90deg);\n  cursor: pointer;\n\n  path {\n    fill: var(--tables-secondary-row-sub-title-icon);\n  }\n}\n\n.arrowIconOpen {\n  transform: rotate(0deg);\n}\n\n.settingItemInfo {\n  margin-top: -15px;\n  border-radius: 0 5px;\n  transition: all 0.5s ease-in-out;\n  border: 1px solid var(--tables-primary-row-stroke);\n  border-top: none;\n  background: var(--tables-secondary-row-sub-title-surface);\n}\n\n.settingItemInfoText {\n  margin-bottom: 0;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--tables-secondary-row-sub-title-text);\n  padding: 15px 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingBlock": `settingBlock__EGXms`,
	"collapseTitle": `collapseTitle__FNPju`,
	"arrowIcon": `arrowIcon__E4gyr`,
	"arrowIconOpen": `arrowIconOpen__qfpwp`,
	"settingItemInfo": `settingItemInfo__WlfpV`,
	"settingItemInfoText": `settingItemInfoText__e7kjd`
};
module.exports = ___CSS_LOADER_EXPORT___;
